import axios from "axios";
import config from "../config";

const service = axios.create({
  baseURL: config.url,
  timeout: 100000,
  headers: {
    // "Access-Control-Allow-Origin": "http://localhost:8000",
    // "Access-Control-Allow-Credentials": true,
    // "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, PATCH",
    // "Access-Control-Allow-Headers": "Content-Type",
  },
});

export default service;
